import { gql } from '@apollo/client';

export const ScheduleEntryStatuses = {
  UPCOMING: { key: 'UPCOMING', label: 'Upcoming', color: 'default' },
  DUE: { key: 'DUE', label: 'Due', color: 'blue' },
  OVERDUE: { key: 'OVERDUE', label: 'Overdue', color: 'red' },
  SUBMITTED: { key: 'SUBMITTED', label: 'Submitted', color: 'gold' },
  APPROVED: { key: 'APPROVED', label: 'Approved', color: 'green' },
  SKIPPED: { key: 'SKIPPED', label: 'Skipped', color: 'default' },
};

export const ScheduleFrequencies = {
  WEEKLY: { key: 'WEEKLY', label: 'Weekly', color: 'blue' },
  MONTHLY: { key: 'MONTHLY', label: 'Monthly', color: 'green' },
  QUARTERLY: { key: 'QUARTERLY', label: 'Quarterly', color: 'orange' },
  CUSTOM: { key: 'CUSTOM', label: 'Custom', color: 'purple' },
};

export const FormFieldTypes = {
  TEXT: { key: 'TEXT', label: 'Text' },
  TEXTAREA: { key: 'TEXTAREA', label: 'Text Area' },
  NUMBER: { key: 'NUMBER', label: 'Number' },
  CURRENCY: { key: 'CURRENCY', label: 'Currency' },
  SELECT: { key: 'SELECT', label: 'Select' },
  MULTI_SELECT: { key: 'MULTI_SELECT', label: 'Multi Select' },
  CHECKBOX: { key: 'CHECKBOX', label: 'Checkbox' },
  DATE: { key: 'DATE', label: 'Date' },
  FILE_UPLOAD: { key: 'FILE_UPLOAD', label: 'File Upload' },
};

export const reportScheduleAttributes = gql`
  {
    _id
    holisticProjectId
    proposalId
    entries {
      entryId
      templateId
      dueDate
      frequency
      status
      scheduledReportId
      label
    }
    defaultWeeklyTemplateId
    defaultMonthlyTemplateId
    defaultQuarterlyTemplateId
    isActive
    createdBy
    updatedBy
    createdAt
    updatedAt
  }
`;

export const reportScheduleTemplateListAttributes = gql`
  {
    _id
    name
    description
    frequency
    formFields {
      fieldId
      fieldType
      label
      required
      options
      placeholder
      helpText
      order
    }
    isArchived
    createdAt
    updatedAt
  }
`;

export const reportScheduleByProposalQuery = gql`
  query ReportScheduleByProposal($proposalId: ID!) {
    reportScheduleByProposal(proposalId: $proposalId) ${reportScheduleAttributes}
  }
`;

export const reportScheduleByProjectQuery = gql`
  query ReportScheduleByProject($holisticProjectId: ID!) {
    reportScheduleByProject(holisticProjectId: $holisticProjectId) ${reportScheduleAttributes}
  }
`;

export const reportScheduleQuery = gql`
  query ReportSchedule($_id: ID!) {
    reportSchedule(_id: $_id) ${reportScheduleAttributes}
  }
`;

export const reportScheduleForUserQuery = gql`
  query ReportScheduleForUser($_id: ID!) {
    reportScheduleForUser(_id: $_id) ${reportScheduleAttributes}
  }
`;

export const reportScheduleByProjectForUserQuery = gql`
  query ReportScheduleByProjectForUser($holisticProjectId: ID!) {
    reportScheduleByProjectForUser(holisticProjectId: $holisticProjectId) ${reportScheduleAttributes}
  }
`;

export const allReportScheduleTemplatesForUserQuery = gql`
  query AllReportScheduleTemplatesForUser(
    $first: Int
    $after: String
    $filters: ReportScheduleTemplateFilters
    $sortBy: [SortBy]
  ) {
    allReportScheduleTemplatesForUser(
      first: $first
      after: $after
      filters: $filters
      sortBy: $sortBy
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node ${reportScheduleTemplateListAttributes}
      }
    }
  }
`;

export const createReportScheduleMutation = gql`
  mutation CreateReportSchedule($schedule: ReportScheduleCreateInput!) {
    createReportSchedule(schedule: $schedule) {
      schedule ${reportScheduleAttributes}
    }
  }
`;

export const updateReportScheduleMutation = gql`
  mutation UpdateReportSchedule($schedule: ReportScheduleUpdateInput!) {
    updateReportSchedule(schedule: $schedule) {
      schedule ${reportScheduleAttributes}
    }
  }
`;

export const deleteReportScheduleMutation = gql`
  mutation DeleteReportSchedule($_id: ID!) {
    deleteReportSchedule(_id: $_id) {
      deletedId
    }
  }
`;

export const generateDefaultScheduleQuery = gql`
  query GenerateDefaultSchedule($input: GenerateDefaultScheduleInput!) {
    generateDefaultSchedule(input: $input) {
      entries {
        entryId
        templateId
        dueDate
        frequency
        status
        label
      }
    }
  }
`;

export const allReportScheduleTemplatesQuery = gql`
  query AllReportScheduleTemplatesShared(
    $first: Int
    $after: String
    $filters: ReportScheduleTemplateFilters
    $sortBy: [SortBy]
  ) {
    allReportScheduleTemplates(
      first: $first
      after: $after
      filters: $filters
      sortBy: $sortBy
    ) {
      pageInfo {
        hasNextPage
        endCursor
      }
      edges {
        node ${reportScheduleTemplateListAttributes}
      }
    }
  }
`;

export const reportScheduleUpdatesSubscription = gql`
  subscription ReportScheduleUpdates {
    reportScheduleUpdates {
      crud
      id
      new ${reportScheduleAttributes}
    }
  }
`;

export const allScheduledEntriesForAdminQuery = gql`
  query AllScheduledEntriesForAdmin {
    allScheduledEntriesForAdmin {
      entryId
      scheduleId
      holisticProjectId
      holisticProject {
        _id
        projectName
        projectNo
        projectNumber
      }
      dueDate
      frequency
      status
      label
      templateId
      scheduledReportId
      reminderSentAt
    }
  }
`;
